// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_pb-0";